import { ChevronLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";
import Card from "../Home/Recent";
import clsx from 'clsx';
import {useThemeClass} from '@/Hooks/useThemeClass'

function InterestCampaign() {
  const themeClass = useThemeClass()
  return (
    <div className="px-3">
      <div className={`${clsx(themeClass.text('text'), themeClass.border("text"))} justify-between flex items-center py-4 border-b`}>
        <Link to={"/mypage"}>
          <ChevronLeft />
        </Link>
        <div>
          <p className="text-[20px] font-bold">
            흥미로운 캠페인
          </p>
        </div>
        <Link to={"/"} className="flex text-[12px] items-center text-center">
          <Home />
        </Link>
      </div>
      <Card ctgId={0} />
    </div>
  );
}

export default InterestCampaign;
